import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function FailedSolutions() {
  const failures = ['Over-the-counter pills only mask the pain for four hours while leaving your stomach feeling acidic and sensitive.', 'Expensive "joint supplements" and turmeric gummies often lack the "activation" ingredients needed to actually reach your bloodstream.', 'Traditional "Senior Diets" are often bland, depressing, and require too much standing-time in the kitchen.', "Rigid exclusion diets are impossible to maintain because they don't account for your real life, your grandkids, or your travel plans."];
  return <section className="bg-white py-6 px-4 md:px-8" data-id="element-17">
      <div className="max-w-2xl mx-auto" data-id="element-18">
        <FadeIn data-id="element-19">
          <h2 className="text-xl md:text-2xl font-bold text-forest mb-3 text-center" data-id="element-20">
            Why Nothing Has Worked... Until Now
          </h2>
        </FadeIn>

        <div className="space-y-2" data-id="element-21">
          {failures.map((failure, index) => <FadeIn key={index} delay={0.08 * (index + 1)} data-id="element-22">
              <div className="flex items-start gap-3 bg-cream p-3 rounded-lg" data-id="element-23">
                <XCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-24" />
                <p className="text-sm md:text-base text-charcoal leading-relaxed" data-id="element-25">
                  {failure}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}